<div class="job-break-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Job Break - {{ data.employee.display_name }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-icon-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="form" class="break-form">
      <div class="form-row">
        <div class="form-field-group date-field">
          <label class="field-label">Start Date*</label>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="startPicker" formControlName="start_date" placeholder="Select date" cdkFocusInitial>
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="form-field-group date-field">
          <label class="field-label">End Date*</label>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="endPicker" formControlName="end_date" placeholder="Select date">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="form-field-group full-width">
          <label class="field-label">Leave Type*</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="leave_type_id" placeholder="Select Leave Type">
              <mat-option *ngFor="let lt of leaveTypes" [value]="lt.id">{{ lt.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-group full-width">
        <label class="field-label">Remarks</label>
        <mat-form-field appearance="outline">
          <textarea matInput formControlName="remarks" rows="2" placeholder="Type remarks (optional)"></textarea>
        </mat-form-field>
      </div>

    </form>

    <div class="breaks-list-section">
      <div class="breaks-list-header">
        <h3>Saved Job Breaks</h3>
        <div class="form-actions">
          <button mat-button (click)="resetForm()" *ngIf="form.get('id')?.value" class="btn-cancel">Cancel</button>
          <button mat-flat-button class="btn-add-break" (click)="onSave()" [disabled]="form.invalid || isSaving">
            {{ form.get('id')?.value ? 'Update Break' : 'Add New Break' }}
          </button>
        </div>
      </div>
      <div class="table-container">
        <table class="breaks-table">
          <thead>
            <tr>
              <th style="width: 18%;">Start Date</th>
              <th style="width: 18%;">End Date</th>
              <th style="width: 49%;">Leave Type</th>
              <th style="width: 15%; text-align: center;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of breaks">
              <td>{{ item.start_date | date:'dd-MM-yyyy' }}</td>
              <td>{{ item.end_date | date:'dd-MM-yyyy' }}</td>
              <td>{{ item.leave_type_name || '—' }}</td>
              <td class="actions">
                <button mat-icon-button (click)="onEdit(item)" matTooltip="Edit" class="edit-btn">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button (click)="onDelete(item)" matTooltip="Delete" class="delete-btn">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
            <tr *ngIf="breaks.length === 0">
              <td colspan="4" class="no-data">No job breaks found for this employee.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <div class="dialog-footer">
    <button mat-flat-button class="btn-close" (click)="onClose()">
      <mat-icon>close</mat-icon> Close
    </button>
  </div>
</div>
